const actions = {
  BULK_ACTIVATION: "BULK_ACTIVATION",
  BULK_ACTIVATION_SUCCESS: "BULK_ACTIVATION_SUCCESS",
  BULK_ACTIVATION_FAILED: "BULK_ACTIVATION_FAILED",


  RESET_MESSAGE: "RESET_MESSAGE",

  createBulkActivation: (data) => ({
    type: actions.BULK_ACTIVATION,
    payload: { data },
  }),
  createBulkActivationSuccess: (message) => ({
    type: actions.BULK_ACTIVATION_SUCCESS,
    payload: { message }
  }),
  createBulkActivationFailed: (error, data) => ({
    type: actions.BULK_ACTIVATION_FAILED,
    payload: { error, data },
  }),

  resetMessage: () => ({
    type: actions.RESET_MESSAGE,
  }),


}

export default actions;